import { IMAGE } from "../../image/image";

export const AccessToCommunity = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="access-to-comunity-container">
          <div className="m-auto-tb">
            <div className="out-fit-title-text-mini">
              Life-time full access<br></br> to the Community Tool
            </div>
            <div className="set-mobile out-fit-detail-text mt-20">
              Each Homies acts as a member card with life-time full access to
              the Community tool. Hodl tight to your homies and more priviledge
              are to come for only members.
            </div>

            <div className="set-desktop out-fit-detail-text mt-20">
              Each Homies acts as a member card with life-time full access{" "}
              <br></br>to the Community tool. Hodl tight to your homies and more{" "}
              <br></br>
              priviledge are to come for only members.
            </div>
          </div>

          <div className="access-image-container">
            <div className="card-position card-position-1">
              <img src={IMAGE.HOMEPAGE.CARD[1]} alt="card 1"></img>
            </div>
            <div className="card-position card-position-2">
              <img src={IMAGE.HOMEPAGE.CARD[2]} alt="card 2"></img>
            </div>
            <div className="card-position card-position-3">
              <img src={IMAGE.HOMEPAGE.CARD[4]} alt="card 3"></img>
            </div>
            <div className="card-position card-position-4">
              <img src={IMAGE.HOMEPAGE.CARD[3]} alt="card 4"></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
